import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCursorList: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"cursor-list, cursor, list"} maskId="square-filled-radius-0-stroke-1-IconCursorList"><path d="M10 3H21V4H10V3Z" fill="currentColor"/><path d="M15 7H21V8H15V7Z" fill="currentColor"/><path d="M7.71332 21.3689L2.67773 7.17773L16.8689 12.2133L12.6447 16.4376L17.7072 21.5001L17.0001 22.2072L11.9376 17.1447L7.71332 21.3689Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCursorList;
